export const FilterValues = {
  active: 'active',
  draft: 'draft',
  archive: 'archive',
  my: 'my',
  all: 'all',
  bookmark: 'bookmark',
} as const;

export type TFilterValues = (typeof FilterValues)[keyof typeof FilterValues];

export type MfCampaignAppConfig = {
  API_ROOT: string;
  CREATIVE_BUILDS_URL: string;
  CREATIVE_MANIFEST_URL: string;
  DOWNLOAD_URL: string;
  EXPORT_URL: string;
  FILE_URL: string;
  IMG_URL: string;
  KEYCLOAK_CLIENT_ID: string;
  KEYCLOAK_REALM: string;
  KEYCLOAK_URL: string;
  MAPBOX_TOKEN: string;
  MAPBOX_URL: string;
  MF_REMOTE_ADCREATOR_URL: string;
  MF_REMOTE_BOOKING_URL: string;
  MF_REMOTE_MAP_URL: string;
  MF_REMOTE_TARGETING_URL: string;
  MF_REMOTE_REPORTING_URL: string;
  MF_REMOTE_PREVIEW_URL: string;
  ORG_ID: string;
  PREVIEW_F11_HOST: string;
  PREVIEW_NEUTRAL_HOST: string;
  STAGE_HOST_LIVE: string;
  STAGE_HOST_PREVIEW: string;
  SUPPORTED_LANGUAGES: string;
  THEME_DEFAULT?: string;
  THEME_URL: string;
};
